/**
 * Helpers do método "Pontos" — programa fake genérico.
 * Razão: 100 pontos = R$ 1.
 */

const POINTS_FORMATTER = new Intl.NumberFormat('pt-BR');

export function formatPoints(n: number): string {
  return POINTS_FORMATTER.format(Math.round(n));
}
